import z from "zod";

import { User } from "@/shared/domains/users";
import { availableLanguageSchema } from "@/shared/models";

export const Login = z.object({
  email: User.shape.email,
  password: z.string(),
});
export type Login = z.infer<typeof Login>;

export const Authorize = z.object({
  accessToken: z.string(),
  preferredLanguage: availableLanguageSchema,
});
export type Authorize = z.infer<typeof Authorize>;
